import { Middleware } from '@reduxjs/toolkit';
import { ACTION_BREADCRUMB_BUFFER_SIZE } from 'data/error-log-constants';
import { ReduxActionBreadcrumbType } from 'types/error-log';
import { nextSequence } from 'utils/error-log/sequence';

const breadcrumbs: ReduxActionBreadcrumbType[] = [];

function readActionType(action: unknown): string | null {
  if (!action || typeof action !== 'object') {
    return null;
  }
  const { type } = action as { type?: unknown };
  return typeof type === 'string' ? type : null;
}

export const actionBreadcrumbsMiddleware: Middleware =
  () => (next) => (action) => {
    const type = readActionType(action);
    if (type) {
      breadcrumbs.push({ id: nextSequence(), timestamp: Date.now(), type });
      if (breadcrumbs.length > ACTION_BREADCRUMB_BUFFER_SIZE) {
        breadcrumbs.shift();
      }
    }
    return next(action);
  };

export function getRecentReduxActions(): ReduxActionBreadcrumbType[] {
  return [...breadcrumbs];
}

export function resetActionBreadcrumbs() {
  breadcrumbs.length = 0;
}
